import React, { useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { tables, Buttons, inputFields, Spacer } from "../../components";

const CountryList = () => {
  const navigate = useNavigate();

  const { countries, isCountryLoading } = useSelector((state) => state?.others);

  const [searchQuery, setSearchQuery] = useState("");

  const filteredCountries = useMemo(() => {
    if (!searchQuery) return countries;
    const lowerCaseQuery = searchQuery.toLowerCase();
    return countries.filter(
      (country) =>
        country.name.toLowerCase().includes(lowerCaseQuery) ||
        (country.countryCode &&
          country.countryCode.toLowerCase().includes(lowerCaseQuery)) ||
        (country.Continent?.name &&
          country.Continent.name.toLowerCase().includes(lowerCaseQuery))
    );
  }, [countries, searchQuery]);

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      width: 80,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Country",
      dataIndex: "country",

      render: (text, record) => record?.name,
    },
    {
      title: "Country Code",
      dataIndex: "countryCode",

      render: (text, record) => record?.countryCode,
    },
    {
      title: "Continent",
      dataIndex: "continent",

      render: (text, record) => record?.Continent?.name,
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 80,
      fixed: "right",
      render: (text, record) => (
        <Link
          to={`/country/edit-country/${record.id}`}
          className="w-full flex justify-center items-center gap-2"
          onClick={(e) => e.stopPropagation()}
        >
          <FaEdit className="text-3xl text-yellow-400" />
        </Link>
      ),
    },
  ];

  return (
    <div className="text-black">
      <div className="flex justify-between gap-3">
        <inputFields.DefaultSearchBox
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search country..."
        />
        <div className="w-[10.5em]">
          <Buttons.DefaultButton
            onClick={() => navigate("/country/add")}
            size="medium"
            width="max"
          >
            Add Country
          </Buttons.DefaultButton>
        </div>
      </div>
      <Spacer height={20} />
      <div className="w-[calc(100vw-20em)] overflow-x-auto max-w-full relative">
        <tables.DefaultTable
          dataSource={filteredCountries}
          columns={columns}
          rowKey={(record, index) => index}
          pagination={false}
          loading={isCountryLoading}
          onRow={(record, index) => ({
            onClick: (event) => {
              if (event.ctrlKey) {
                window.open(`/country/${record.id}`, "_blank");
              } else {
                navigate(`/country/${record.id}`);
              }
            },
          })}
        />
      </div>
    </div>
  );
};

export default CountryList;
